import classNames from "classnames";
import styles from "./DayChooser.module.scss";
import cn from "classnames";
import OrigArrowLeft from "@assets/redesign/icons/arrowPrevious.svg";
import OrigArrowRight from "@assets/redesign/icons/arrowNextDisabled.svg";
import WlpArrowLeft from "../WLP202603/assets/day-chooser-prev.svg";
import WlpArrowRight from "../WLP202603/assets/day-chooser-next-disabled.svg";
import { Moment } from "moment-timezone";
import { todayUtc } from "@utils/moscowTime";
import { useMemo } from "react";
import { WLP202603 } from "../../config";

interface DayChooserProps {
  currentDay: Moment;
  disabled: boolean;
  style?: React.CSSProperties;
  onDayChanged: (day: Moment) => void;
}

const ArrowLeft = WLP202603 ? WlpArrowLeft : OrigArrowLeft;
const ArrowRight = WLP202603 ? WlpArrowRight : OrigArrowRight;

function DayChooser({
  currentDay,
  disabled,
  style,

  onDayChanged,
}: DayChooserProps): JSX.Element {
  const incDay = () => {
    onDayChanged(currentDay.clone().add(1, "days"));
  };

  const decDay = () => {
    onDayChanged(currentDay.clone().add(-1, "days"));
  };

  const noNext = useMemo(() => currentDay.isAfter(todayUtc().add(-1, "days")), [currentDay]);

  return (
    <div
      className={classNames(styles.btns, {
        [styles.disabled]: disabled,
      })}
      style={style}
    >
      <img
        src={ArrowLeft}
        className={styles.icon}
        onClick={decDay}
        alt='Back'
      />
      <p>{currentDay.format("DD.MM.YYYY")}</p>
      <img
        src={noNext ? ArrowRight : ArrowLeft}
        className={cn(styles.icon, {
          [styles.none]: noNext,
          [styles.rotate]: !noNext,
        })}
        onClick={incDay}
        alt=''
      />
    </div>
  );
}

export default DayChooser;
